<template>
  <section>
    <LoadingSpinner v-if="loading" />
    <!-- Table (list orders) + -->
    <div v-else class="mx-2">
      <!-- Button delete user -->
      <div class="col-md-12 w-100 my-2 card p-2">
        <div class="ml-3 mb-2">
          <button
              @click="executeAction('delete')"
              :disabled="orders.filter(el => el.checkToAction).length == 0"
              class="btn btn-sm btn-danger mr-2"
            >
              <i class="mr-1 icon-remove"></i>{{ $t("lang.button.deleteteam") }}
            </button>
        </div>
      </div>

      <div class="col-md-12 w-100 my-2 card p-2">
        <div class="mx-0 px-0 table-responsive">
          <Table
            v-if="!loading && !showEmptyImage"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="orders"
            :checkbox="false"
            :notselect="true"
            :model="model"
            :fieldsLoading="fieldsLoading"
            :key="captainkey"
            @goToAgency="goToAgency"
            @openTarget="openTarget"
            @openClient="openClient"
          >
          </Table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { targetsService, usersService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
  },

  data() {
    return {
      filters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      orders: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "checkToAction",
            type: "checkboxMultiple",
          },
        ],
        [
          {
            value: "task_open_hours",
            type: "time",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "sales_name",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            textShort: 40,
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "1",
                badge_class: "badge badge-primary text-white",
                badge_label: this.$t("lang.targets.active"),
                badge_tooltip: this.$t("lang.orders.status_prepare_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "2",
                badge_class: "badge badge-danger text-white",
                badge_label: this.$t("lang.targets.stopped"),
                badge_tooltip: this.$t("lang.orders.status_inactive_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "3",
                badge_class: "badge badge-secondary text-white",
                badge_label: this.$t("lang.targets.pending"),
                badge_tooltip: this.$t("lang.orders.status_draft_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: this.$t("lang.targets.running"),
                badge_tooltip: this.$t("lang.orders.status_active_tooltip"),
              },
              {
                badge_if: "target_status_id",
                badge_value: "5",
                badge_class: "badge badge-warning text-white",
                badge_label: this.$t("lang.targets.archived"),
                badge_tooltip: this.$t("lang.orders.status_achived_tooltip"),
              },
            ],
          },
        ],
        [
          {
            value: "last_sent_label",
          },
        ],
        [
          {
            value: "available_contacts",
          },
        ],
        [
          {
            value: "running_date",
          },
        ],
      ],
      headers: [
        {
          label: "Select",
          percentage: "2.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: "Time",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
          id: 2,
        },
        {
          label: "Sales",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 3,
        },
        {
          label: this.$t("lang.label.target"),
          class: "overflowhide",
          id: 4,
        },
        {
          label: "Last email sent",
          class: "overflowhide",
          id: 5,
        },
        {
          label: "Available contacts",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Running since",
          class: "overflowhide",
          id: 7,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },

  mounted() {
    this.loadSales();
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
  },

  props: {
    client_id: {
      type: Number,
      default: undefined,
    },
    fromClient: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    loadSales(order, filter = []) {
      targetsService.getNotProspectingSales("24").then((response) => {
        if (response !== undefined) {
          this.orders = response.result.map(el => ({
            ...el,
            checkToAction: false,
            last_sent_label: el.days_since_last_sent === null ? "Never" : `${el.days_since_last_sent} days ago`,
          }));
          this.loading = false;
        }
      });
    },

    filter(event) {
      this.filters = event;
      this.loadSales(this.orderStatus, this.filters);
    },

    openTarget(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    goToAgency(client_id, client_name) {
      //(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);
      if (
        !this.hasPermissions("isAgencyManager") ||
        this.hasPermissions("adminAgency")
      ) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      }
    },
    executeAction() {
      this.$swal({
          type: "warning",
          title: this.$t("lang.refuse.sure"),
          html: this.usersAction,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.ok"),
          cancelButtonText: this.$t("lang.button.cancel"),
        }).then((result) => {
          if (result.value) {
            this.loadingDeleteTeam = true;
            const users =  this.orders.filter(el => el.checkToAction).map(el => el.id)
            this.loading = true;
            usersService.deleteUsers(users).then((r) => {
              this.loadSales()
            });
          }
     })
    }
  },
}
</script>
